import { render, staticRenderFns } from "./SocialMediaButton.vue?vue&type=template&id=44d039eb&scoped=true"
import script from "./SocialMediaButton.vue?vue&type=script&lang=js"
export * from "./SocialMediaButton.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaButton.vue?vue&type=style&index=0&id=44d039eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d039eb",
  null
  
)

export default component.exports